import React from "react";
import styled from "styled-components";
import { getCommaNumber } from "utils/format";
import type { PaymentMethodItem, Refund } from "types/ManagerPayment";
import { PAYMENT_METHOD_COLOR, REFUND_COLOR } from "./colors";

interface Props {
  methods: PaymentMethodItem[];
  refund: Refund;
}

export const PaymentMethodList = ({ methods, refund }: Props) => {
  return (
    <List>
      {methods.map((m) => {
        const zero = !m.amount;
        return (
          <li key={m.code} className={zero ? "zero" : undefined}>
            <div className="nm">
              <span
                className="dot"
                style={{ background: PAYMENT_METHOD_COLOR[m.code] }}
              />
              <span className="nmt">{m.name}</span>
              <span className="pct">{m.percentage}%</span>
            </div>
            <div className="amt">{getCommaNumber(m.amount)}원</div>
          </li>
        );
      })}
      <li className={!refund.amount ? "zero" : undefined}>
        <div className="nm">
          <span className="dot" style={{ background: REFUND_COLOR }} />
          <span className="nmt">환불</span>
        </div>
        <div className={"amt" + (refund.amount ? " neg" : "")}>
          {getCommaNumber(refund.amount ? refund.amount * -1 : 0)}원
        </div>
      </li>
    </List>
  );
};

const List = styled.ul`
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 0;
    border-top: 1px solid var(--lightBorder);
  }
  li .nm {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  li .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex: none;
  }
  li .nmt {
    font-size: var(--14px);
    line-height: 1.3;
    white-space: pre-line;
  }
  li .pct {
    font-size: var(--12px);
    color: #98a0af;
  }
  li .pct:before {
    content: "·";
    margin: 0 0.35em;
  }
  li .amt {
    font-size: var(--14px);
    font-weight: 600;
    text-align: right;
    padding-left: 12px;
    white-space: nowrap;
  }
  li .amt.neg {
    color: ${REFUND_COLOR};
  }
  li.zero .nmt,
  li.zero .amt,
  li.zero .pct {
    color: #b0b7c3;
  }
`;

export default PaymentMethodList;
